module.exports = __webpack_public_path__ + "static/media/Steuerfachwirt_Handout_2025.65b6142d.pdf";